import get from 'lodash/get'

const selectRewardState = state => get(state, 'reward')

export const selectRewardData = state => selectRewardState(state).data
export const selectRewardStatus = state =>
  selectRewardState(state).getRewardStatus
export const selectRedeemRewardStatus = state =>
  selectRewardState(state).redeemRewardStatus
